import { EStatusProposta } from "#/enums";
import { StatusProposta } from "#/types";

export const statusProposta: StatusProposta = {
  [EStatusProposta.PROPOSTA_EM_PROCESSAMENTO]: {
    processamento: {
      etapa: "processing",
      titulo: "Proposta em processamento",
      descricao: "Sua proposta foi recebida pela seguradora.",
    },
    analise: {
      etapa: "pending",
      titulo: "Proposta em análise",
    },
    resultado: {
      etapa: "pending",
      titulo: "Resultado da análise",
    },
  },
  [EStatusProposta.PROPOSTA_EM_ANALISE]: {
    processamento: {
      etapa: "finished",
      titulo: "Proposta em processamento",
    },
    analise: {
      etapa: "processing",
      titulo: "Proposta em análise",
      descricao: "Sua proposta está em análise pela seguradora.",
    },
    resultado: {
      etapa: "pending",
      titulo: "Resultado da análise",
    },
  },
  [EStatusProposta.PROPOSTA_APROVADA]: {
    processamento: {
      etapa: "finished",
      titulo: "Proposta em processamento",
    },
    analise: {
      etapa: "finished",
      titulo: "Proposta em análise",
    },
    resultado: {
      etapa: "finished",
      titulo: "Proposta aprovada",
    },
  },
  [EStatusProposta.APOLICE_EMITIDA]: {
    processamento: {
      etapa: "finished",
      titulo: "Proposta em processamento",
    },
    analise: {
      etapa: "finished",
      titulo: "Proposta em análise",
    },
    resultado: {
      etapa: "finished",
      titulo: "Proposta aprovada",
    },
  },
  [EStatusProposta.PROPOSTA_RECUSADA]: {
    processamento: {
      etapa: "finished",
      titulo: "Proposta em processamento",
    },
    analise: {
      etapa: "finished",
      titulo: "Proposta em análise",
    },
    resultado: {
      etapa: "error",
      titulo: "Proposta recusada",
      descricao:
        "Sua proposta foi recusada pela seguradora. Entre em contato com o seu gerente para saber mais.",
    },
  },
  [EStatusProposta.PROPOSTA_NAO_EFETIVADA]: {
    processamento: {
      etapa: "finished",
      titulo: "Proposta em processamento",
    },
    analise: {
      etapa: "finished",
      titulo: "Proposta em análise",
    },
    resultado: {
      etapa: "error",
      titulo: "Proposta não efetivada",
      descricao:
        "Sua proposta não foi efetivada pela seguradora. Entre em contato com o seu gerente para saber mais.",
    },
  },
  [EStatusProposta.PROPOSTA_EXCLUIDA]: {
    processamento: {
      etapa: "finished",
      titulo: "Proposta em processamento",
    },
    analise: {
      etapa: "finished",
      titulo: "Proposta em análise",
    },
    resultado: {
      etapa: "error",
      titulo: "Proposta excluída",
      descricao:
        "Sua proposta foi excluída pela seguradora. Entre em contato com o seu gerente para saber mais.",
    },
  },
  SEM_STATUS: {
    processamento: {
      etapa: "pending",
      titulo: "Proposta em processamento",
    },
    analise: {
      etapa: "pending",
      titulo: "Proposta em análise",
    },
    resultado: {
      etapa: "pending",
      titulo: "Resultado da análise",
    },
  },
};
